import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface AccountState {
    isAuthed: boolean;
    authChecked: boolean;
}

const initialState: AccountState = {
    isAuthed: false,
    authChecked: false,
};

export const accountSlice = createSlice({
    name: "account",
    initialState,
    reducers: {
        setAuthed: (state, action: PayloadAction<boolean>) => {
            state.isAuthed = action.payload;
        },

        setAuthChecked: (state, action: PayloadAction<boolean>) => {
            state.authChecked = action.payload;
        },
    },
});

export const { setAuthed, setAuthChecked } = accountSlice.actions;

export default accountSlice.reducer;
